<footer [ngClass]="{'sticky-area': footerStyleValue == true}">
  <div class="container" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column">
    <div class="" fxFlex="100" fxFlex.xs="25" fxFlex.sm="100" fxFlex.md="100" style="text-align: left;">
      <a [href]="routerService.getSeamHomePageUrl()"><img [src]="'assets/images/logo.svg'" alt="Biletix"
          class="logo"></a>
      <h2>{{'footer.followUs'|translate}}</h2>
      <ul class="social">
        <!-- İkonlar CSS background-image; link metni yok -> aria-label (Lighthouse link-name) -->
        <li class="facebook"><a href="https://www.facebook.com/Biletix" target="_blank" rel="noopener" aria-label="Facebook"></a></li>
        <li class="twitter"><a href="https://twitter.com/biletix" target="_blank" rel="noopener" aria-label="X (Twitter)"></a></li>
        <li class="blog"><a href="http://blog.biletix.com/" target="_blank" rel="noopener" aria-label="Biletix Blog"></a></li>
        <li class="youtube"><a href="https://www.youtube.com/channel/UCI6ownTOlxgaN0Um74-sC6Q" target="_blank" rel="noopener" aria-label="YouTube"></a></li>
        <li class="instagram"><a href="http://instagram.com/biletix" target="_blank" rel="noopener" aria-label="Instagram"></a></li>
        <li class="linkedin"><a href="https://www.linkedin.com/company/biletix" target="_blank" rel="noopener" aria-label="LinkedIn"></a></li>
        <li class="spotify"><a href="https://open.spotify.com/user/qcjtfkcpiw94n579mfq1h2pq2?si=b02989c27f564710"
            target="_blank" rel="noopener" aria-label="Spotify"></a></li>
        <li class="tiktok"><a href="https://www.tiktok.com/@ticketmasterturkiye?_t=8hM0Q36uYa6&_r=1"
            target="_blank" rel="noopener" aria-label="TikTok"></a></li>
      </ul>
      <h2>{{'footer.ourApps'|translate}}</h2>
      <ul class="app-icon">
        <li *ngIf="currentLocale?.lang=='tr'"><a
            href="https://itunes.apple.com/tr/app/biletix/id1181457295?ls=1&mt=8"><img
              [src]="'assets/images/icon/app-store.svg'" loading="lazy" alt="Biletix Ios App"></a></li>
        <li *ngIf="currentLocale?.lang=='en'"><a
            href="https://itunes.apple.com/tr/app/biletix/id1181457295?ls=1&mt=8"><img
              [src]="'assets/images/icon/app-store-en.png'" loading="lazy" alt="Biletix Ios App"></a></li>
        <li *ngIf="currentLocale?.lang=='tr'"><a
            href="https://play.google.com/store/apps/details?id=com.biletix.ticketmaster"><img
              [src]="'assets/images/icon/play-store.svg'" loading="lazy" alt="Biletix Android App"></a></li>
        <li *ngIf="currentLocale?.lang=='en'"><a
            href="https://play.google.com/store/apps/details?id=com.biletix.ticketmaster"><img
              [src]="'assets/images/icon/play-store-en.png'" loading="lazy" alt="Biletix Android App"></a></li>
      </ul>
    </div>
    <div class="" fxFlex="100" fxFlex.xs="25" fxFlex.sm="100" fxFlex.md="100">
      <div class="footer-column-holder">
        <h2 checkToggle>{{'footer.aboutUs'|translate}}</h2>
        <ul>
          <!-- <li><a [href]="routerService.getSeamPageUrl('about')">{{'footer.whoWeAre'|translate}}</a></li> -->
          <li *ngIf="currentLocale?.lang=='tr'"><a
              href="https://business.ticketmaster.com.tr">{{'footer.whoWeAre'|translate}}</a></li>
          <li *ngIf="currentLocale?.lang=='en'"><a
              href="https://business.ticketmaster.com.tr/en/">{{'footer.whoWeAre'|translate}}</a></li>
          <li><a [href]="routerService.getSeamPageUrl('qualitypolicies')">{{'footer.ourPolicy'|translate}}</a></li>
          <li><a
              href="https://business.ticketmaster.com.tr/marka-varliklari/">{{'footer.visualMaterials'|translate}}</a>
          </li>
          <li><a [href]="routerService.getSeamPageUrl('contactus')">{{'footer.contactUs'|translate}}</a></li>
          <li><a href="http://www.livenation.com/">{{'footer.liveNationEntertainment'|translate}}</a></li>
          <li>
            <a href="https://mths.ttr.com.tr/firmabilgileri.aspx?mersis=0171009936100018">{{"footer.informationSocietyServices"
              | translate }}</a>
          </li>
          <!-- <li><a [href]="routerService.getSeamPageUrl('dunyakansergunu')">{{'footer.socialResponsibility'|translate}}</a></li> -->
        </ul>
      </div>
    </div>
    <div class="" fxFlex="100" fxFlex.xs="25" fxFlex.sm="100" fxFlex.md="100">
      <div class="footer-column-holder">
        <h2 checkToggle>{{'footer.letsHelp'|translate}}</h2>
        <ul>
          <li *ngIf="currentLocale?.lang=='tr'"><a href="https://help.biletix.com/hc/tr">{{'footer.help'|translate}}</a>
          </li>
          <li>
            <a href="https://ticketingtruths.ticketmaster.com.tr/">{{
              "footer.onetrust" | translate
              }}</a>
          </li>
          <li *ngIf="currentLocale?.lang=='en'"><a
              href="https://help.biletix.com/hc/en-us">{{'footer.help'|translate}}</a></li>
          <li><a [href]="routerService.getSeamPageUrl('saleschannel')">{{'footer.salesChannels'|translate}}</a></li>
          <li><a [href]="routerService.accountPageUrl">{{'footer.account'|translate}}</a></li>
          <!-- <li><a [href]="routerService.getSeamPageUrl('deliverymethods')">{{'footer.deliveryOptions'|translate}}</a></li> -->
          <li *ngIf="currentLocale?.lang=='tr'"><a
              [href]="routerService.getGiftCardPageUrl()">{{'footer.giftCard'|translate}}</a></li>
          <!-- <li><a [href]="routerService.getSeamPageUrl('insurance')">{{'footer.eventParticipationInsurance'|translate}}</a></li> -->
          <!-- <li><a href="">{{'footer.internationalEvents'|translate}}</a></li> -->

        </ul>


      </div>
    </div>
    <div class="" fxFlex="100" fxFlex.xs="25" fxFlex.sm="100" fxFlex.md="100">
      <div class="footer-column-holder">
        <h2 checkToggle>{{'footer.workWithUs'|translate}}</h2>
        <ul>
          <li *ngIf="currentLocale?.lang=='tr'"><a href="https://business.ticketmaster.com.tr"
              target="_blank">{{'footer.yourEventTickets'|translate}}</a></li>
          <li *ngIf="currentLocale?.lang=='en'"><a href="https://business.ticketmaster.com.tr/en/"
              target="_blank">{{'footer.yourEventTickets'|translate}}</a></li>
          <li *ngIf="currentLocale?.lang=='tr'"><a href="https://business.ticketmaster.com.tr/bize-ulasin/"
              target="_blank">{{'footer.advertise'|translate}}</a></li>
          <li *ngIf="currentLocale?.lang=='en'"><a href="https://business.ticketmaster.com.tr/en/contact/"
              target="_blank">{{'footer.advertise'|translate}}</a></li>
          <li><a href="https://business.ticketmaster.com.tr/kariyer/" target="_blank">{{'footer.career'|translate}}</a></li>
          <li><a href="https://developer.ticketmaster.com/partners/" target="_blank">
              {{'footer.affiliateProgram'|translate}} </a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container">
    <div fxLayout="column">
      <div class="footer-seperator" fxFlex="100%"></div>
      <h2 checkToggle class="corporate-pages-title">{{'footer.policiesNotices'|translate}}</h2>
      <div class="footer-collapsable" fxFlex="100" fxFlex.xs="25" fxFlex.sm="100" fxFlex.md="100">
        <ul class="corporate-pages">
          <li>
            <a [href]="routerService.getSeamPageUrl('ttk')">{{'footer.TTK'|translate}}</a>
          </li>
          <li *ngIf="currentLocale?.lang=='tr'">
            <a
              href="https://privacy.ticketmaster.com.tr/tr/privacy-policy">{{'footer.aboutProtectionOfPersonalData'|translate}}</a>
          </li>
          <li *ngIf="currentLocale?.lang=='en'">
            <a
              href="https://privacy.ticketmaster.com.tr/privacy-policy">{{'footer.aboutProtectionOfPersonalData'|translate}}</a>
          </li>
          <li *ngIf="currentLocale?.lang=='tr'">
            <a href="https://privacy.ticketmaster.com.tr/tr/cookie-policy">{{'footer.cookiePolicy'|translate}}</a>
          </li>
          <li *ngIf="currentLocale?.lang=='en'">
            <a href="https://privacy.ticketmaster.com.tr/cookie-policy">{{'footer.cookiePolicy'|translate}}</a>
          </li>
          <li>
            <a href="javascript:void(0)" onclick="ketch('showExperience'); return false;">{{'footer.cookieConsent'|translate}}</a>
          </li>
          <li>
            <a [href]="routerService.getSeamPageUrl('ourpolicies')">{{'footer.contractAndPolicies'|translate}}</a>
          </li>
        </ul>
        <span class="trademark" title={{version}}>{{'footer.trademark'|translate}}</span>
        <span class="trademark-term">{{'footer.trademarkTerm'|translate}}</span>
      </div>
    </div>
  </div>

</footer>